import React from 'react';
import PropTypes from 'prop-types';
import { FlexBaseCol } from '@contently/toolkit';
import styled from '@emotion/styled';
import Filter from './filter';

export default function FilterWrapper({ filterState, setFilterState }) {
  const FilterDiv = styled('div')`
    text-align: right;
    margin-right: 18px;
  `;

  return (
    <FlexBaseCol>
      <FilterDiv>
        <Filter filterState={filterState} setFilterState={setFilterState} />
      </FilterDiv>
    </FlexBaseCol>
  );
}

FilterWrapper.propTypes = {
  filterState: PropTypes.string.isRequired,
  setFilterState: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/filter_wrapper.jsx